import React from 'react';
import { styled } from '@elliemae/ds-system';
import { type SvgIconT } from '@elliemae/ds-icons';

const AugmentedIcon = (Icon: React.ComponentType<{ color: unknown; tabIndex: number }>) => styled(Icon)`
  cursor: pointer;

  outline: 0;
  :focus,
  :active {
    outline: 1px solid #1e79c2;
  }
`;

export const Icon = (IconComponent: React.ComponentType<{ color: unknown; tabIndex: number }>) =>
  function (props?: SvgIconT.Props): JSX.Element {
    const StyledComponent = AugmentedIcon(IconComponent);
    return <StyledComponent color={['brand-primary', '800']} tabIndex={0} {...props} />;
  };
